export default __webpack_public_path__ + "static/media/invite_team.c39e703a.png";